document.addEventListener('DOMContentLoaded',()=>{
  const h=document.querySelector('[data-header]');
  if(h?.classList.contains('header-overlay')){const update=()=>h.classList.toggle('scrolled',scrollY>40);update();addEventListener('scroll',update,{passive:true})}
  const media=[...document.querySelectorAll('[data-media]')];
  document.querySelectorAll('[data-thumb]').forEach(b=>b.addEventListener('click',()=>{
    media.forEach(m=>m.style.display=m.dataset.media===b.dataset.thumb?'block':'none');
    document.querySelectorAll('[data-thumb]').forEach(x=>x.classList.toggle('active',x===b));
  }));
  document.querySelectorAll('[data-qty-minus]').forEach(b=>b.addEventListener('click',()=>{const i=b.parentElement.querySelector('input');i.value=Math.max(1,(parseInt(i.value)||1)-1)}));
  document.querySelectorAll('[data-qty-plus]').forEach(b=>b.addEventListener('click',()=>{const i=b.parentElement.querySelector('input');i.value=(parseInt(i.value)||1)+1}));
  document.querySelectorAll('[data-cart-qty-minus]').forEach(b=>b.addEventListener('click',()=>{const i=b.parentElement.querySelector('input');i.value=Math.max(0,(parseInt(i.value)||0)-1)}));
  document.querySelectorAll('[data-cart-qty-plus]').forEach(b=>b.addEventListener('click',()=>{const i=b.parentElement.querySelector('input');i.value=(parseInt(i.value)||0)+1}));
  document.querySelectorAll('[data-filter-toggle]').forEach(b=>b.addEventListener('click',()=>{
    const panel=document.querySelector('[data-filter-panel]');
    if(!panel)return;
    const open=panel.hasAttribute('hidden');
    panel.toggleAttribute('hidden',!open);
    b.setAttribute('aria-expanded',String(open));
  }));
  document.querySelectorAll('[data-sort-select]').forEach(s=>s.addEventListener('change',()=>s.form?.submit()));
  document.querySelectorAll('.product-form').forEach(form=>{
    const variantsEl=form.querySelector('[data-product-variants]');
    const variantSelect=form.querySelector('.variant-select');
    const submit=form.querySelector('.add-to-cart');
    const message=form.querySelector('[data-product-message]');
    const productPage=form.closest('.product-page');
    const priceDisplay=productPage?.querySelector('[data-product-price]');
    const skuDisplay=productPage?.querySelector('[data-product-sku]');
    const availabilityDisplay=productPage?.querySelector('[data-product-availability]');
    const variants=variantsEl?JSON.parse(variantsEl.textContent):[];
    const setMessage=(text,type='')=>{
      if(!message)return;
      message.textContent=text;
      message.className=`product-form-message${type?` is-${type}`:''}`;
    };
    const selectedOptions=()=>[...form.querySelectorAll('[data-option-position]')]
      .filter(i=>i.checked)
      .sort((a,b)=>Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition))
      .map(i=>i.value);
    const selectedVariant=()=>{
      const selected=selectedOptions();
      if(!selected.length&&variantSelect){
        return variants.find(v=>String(v.id)===String(variantSelect.value))||variants.find(v=>v.available)||variants[0];
      }
      return variants.find(v=>v.options?.length===selected.length&&v.options.every((o,i)=>o===selected[i]));
    };
    const syncVariant=()=>{
      if(!variants.length||!variantSelect)return;
      const variant=selectedVariant();
      const available=!!variant?.available;
      if(variant)variantSelect.value=String(variant.id);
      const selectedOption=variantSelect.options[variantSelect.selectedIndex];
      if(priceDisplay&&selectedOption){
        const price=selectedOption.dataset.price||'';
        const comparePrice=selectedOption.dataset.comparePrice||'';
        const discount=Number(selectedOption.dataset.discount||0);
        priceDisplay.classList.toggle('product-price--sale',discount>0);
        priceDisplay.innerHTML=discount>0
          ? `<span class="product-price__current">${price}</span><s class="product-price__compare">${comparePrice}</s><span class="product-price__discount">-${discount}%</span>`
          : `<span class="product-price__current">${price}</span>`;
      }
      if(skuDisplay&&selectedOption){
        const sku=selectedOption.dataset.sku||'';
        skuDisplay.textContent=sku?`SKU: ${sku}`:'';
        skuDisplay.hidden=!sku;
      }
      if(availabilityDisplay){
        availabilityDisplay.textContent=available?'In stock':(variant?'Sold out':'Unavailable');
        availabilityDisplay.classList.toggle('is-unavailable',!available);
      }
      if(submit){
        submit.disabled=!available;
        submit.textContent=available?'Add to Bag':(variant?'Sold out':'Unavailable');
      }
      const wishlistButton=form.querySelector('[data-wishlist-toggle]');
      if(wishlistButton&&variant){
        wishlistButton.dataset.variantId=String(variant.id);
        wishlistButton.dataset.variantTitle=variant.title==='Default Title'?'':variant.title;
        wishlistButton.dataset.price=String(variant.price);
        if(selectedOption)wishlistButton.dataset.priceFormatted=selectedOption.dataset.price||'';
        document.dispatchEvent(new CustomEvent('wishlist:variant-change',{detail:{button:wishlistButton}}));
      }
      setMessage('');
    };
    form.querySelectorAll('[data-option-position]').forEach(i=>i.addEventListener('change',syncVariant));
    syncVariant();
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      if(!submit||submit.disabled)return;
      const original=submit.textContent;
      submit.disabled=true;
      submit.textContent='Adding...';
      setMessage('');
      try{
        const res=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        const data=await res.json();
        if(!res.ok)throw new Error(data.description||data.message||'Could not add to bag.');
        submit.textContent='Added';
        submit.classList.add('is-added');
        setMessage('Added to bag.', 'success');
        const cart=await fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
        const cartIcon=document.querySelector('.cart-icon');
        if(cartIcon){
          let count=cartIcon.querySelector('b');
          if(!count){count=document.createElement('b');cartIcon.appendChild(count)}
          count.textContent=cart.item_count;
        }
        setTimeout(()=>{submit.textContent=original;submit.classList.remove('is-added');submit.disabled=false},1800);
      }catch(err){
        submit.textContent=original;
        submit.disabled=false;
        setMessage(err.message||'Could not add to bag.', 'error');
      }
    });
  });
});

(()=>{
  const STORAGE_KEY='michaela_wishlist_v1';
  const read=()=>{try{const value=JSON.parse(localStorage.getItem(STORAGE_KEY)||'[]');return Array.isArray(value)?value:[]}catch{return[]}};
  const write=items=>{localStorage.setItem(STORAGE_KEY,JSON.stringify(items));document.dispatchEvent(new CustomEvent('wishlist:change',{detail:{items}}))};
  const key=item=>String(item.variantId||item.productId);
  const fromButton=button=>({
    productId:button.dataset.productId,
    variantId:button.dataset.variantId,
    handle:button.dataset.productHandle,
    url:button.dataset.productUrl,
    title:button.dataset.productTitle,
    vendor:button.dataset.productVendor,
    variantTitle:button.dataset.variantTitle||'',
    price:Number(button.dataset.price||0),
    priceFormatted:button.dataset.priceFormatted||'',
    image:button.dataset.image||''
  });
  const has=(items,item)=>items.some(saved=>key(saved)===key(item));
  const updateButtons=()=>{
    const items=read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(button=>{
      const active=has(items,fromButton(button));
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
      button.setAttribute('aria-label',`${active?'Remove':'Add'} ${button.dataset.productTitle||'product'} ${active?'from':'to'} wishlist`);
      const label=button.querySelector('[data-wishlist-label]');
      if(label)label.textContent=active?'Added to Wishlist':'Add to Wishlist';
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(badge=>{badge.textContent=items.length;badge.hidden=items.length===0});
  };
  const escapeHtml=value=>String(value||'').replace(/[&<>'"]/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const renderPage=()=>{
    const page=document.querySelector('[data-wishlist-page]');if(!page)return;
    const items=read(),grid=page.querySelector('[data-wishlist-grid]'),empty=page.querySelector('[data-wishlist-empty]'),summary=page.querySelector('[data-wishlist-summary]');
    empty.hidden=items.length>0;grid.hidden=items.length===0;summary.textContent=items.length?`${items.length} saved ${items.length===1?'item':'items'}`:'';
    grid.innerHTML=items.map(item=>`<article class="wishlist-item" data-wishlist-item="${escapeHtml(key(item))}">
      <a class="wishlist-item__image" href="${escapeHtml(item.url)}">${item.image?`<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`:''}</a>
      <div class="wishlist-item__content"><small>${escapeHtml(item.vendor)}</small><h2><a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a></h2>${item.variantTitle?`<p class="wishlist-item__variant">${escapeHtml(item.variantTitle)}</p>`:''}<p class="wishlist-item__price">${escapeHtml(item.priceFormatted)}</p></div>
      <div class="wishlist-item__actions"><button class="button button-dark" type="button" data-wishlist-add-cart data-variant-id="${escapeHtml(item.variantId)}">Add to Cart</button><button class="wishlist-remove" type="button" data-wishlist-remove="${escapeHtml(key(item))}">Remove</button><p role="status" data-wishlist-item-status></p></div>
    </article>`).join('');
  };
  document.addEventListener('click',async event=>{
    const toggle=event.target.closest('[data-wishlist-toggle]');
    if(toggle){event.preventDefault();event.stopPropagation();let items=read();const item=fromButton(toggle);items=has(items,item)?items.filter(saved=>key(saved)!==key(item)):[...items,item];write(items);return}
    const remove=event.target.closest('[data-wishlist-remove]');
    if(remove){write(read().filter(item=>key(item)!==remove.dataset.wishlistRemove));return}
    const add=event.target.closest('[data-wishlist-add-cart]');
    if(add){const status=add.parentElement.querySelector('[data-wishlist-item-status]'),original=add.textContent;add.disabled=true;add.textContent='Adding...';try{const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(add.dataset.variantId),quantity:1}]})});const data=await response.json();if(!response.ok)throw new Error(data.description||'Could not add to cart.');add.textContent='Added';if(status)status.textContent='Added to cart.';setTimeout(()=>{add.textContent=original;add.disabled=false},1400)}catch(error){add.textContent=original;add.disabled=false;if(status)status.textContent=error.message}}
  });
  document.addEventListener('wishlist:change',()=>{updateButtons();renderPage()});
  document.addEventListener('wishlist:variant-change',updateButtons);
  window.addEventListener('storage',event=>{if(event.key===STORAGE_KEY){updateButtons();renderPage()}});
  document.addEventListener('DOMContentLoaded',()=>{updateButtons();renderPage()});
})();
